<div class="p-d-flex p-flex-column paket-card" [ngClass]="{'paket-border p-p-3': isMain, 'disabled-card': isDisabled, 'p-mt-4': !isMain }"
     (click)="onCardClicked()"
>
  <div class="p-d-flex p-flex-row p-ai-center p-jc-between package-header" [ngClass]="{'disabled-card': isDisabled }">

    <!-- checkbox -->
    <div *ngIf="!showIncrementInput" class="p-field-checkbox" [ngStyle]="{'pointer-events': isMain ? 'none' : 'default'}">
      <p-checkbox
        [binary]="true"
        [formControl]="formControl"
        [disabled]="isDisabled"
        (onChange)="onCheckboxChange($event.checked)"
        >
      </p-checkbox>
      <label [ngClass]="isDisabled ? 'package-name-disabled' : 'package-name'" (click)="onLabelClicked()">
        {{ label }}
      </label>
    </div>

    <!-- input -->
    <div *ngIf="showIncrementInput" class="custom-number-input flex-1">
      <label [ngClass]="isDisabled ? 'package-name-disabled' : 'package-name'">
        {{ label }}
      </label>
      <kodit-number-input
        [isDisabled]="isDisabled"
        [buttonLayout]="'horizontal'"
        [ctrlMinValue]="0"
        [ctrlOnlyIntegers]="true"
        [formCtrl]="incrementControl"
        [decrementButtonClass]="'p-button-danger'"
        [decrementButtonIcon]="'pi pi-minus'"
        [incrementButtonClass]="'p-button-success'"
        [incrementButtonIcon]="'pi pi-plus'"
        [showButtons]="true"
        [spinnerMode]="'horizontal'"
      >
      </kodit-number-input>
    </div>

    <div>
      <span  [ngClass]="isDisabled && shouldDisablePrice ? 'price-text disabled' : 'price-text'"><span *ngIf="!isMain">+</span>{{ price | number: '1.0-0' }}</span>
      <span class="price-description-text"> {{ priceLabel }}</span>
    </div>
  </div>
</div>
